/* GameEditorTitleComponent.js */

'use strict';
const EventEmitter = require('events').EventEmitter;
const Renderer = require('./GameEditorTitleRenderer');
const _ = require('lodash');

class GameEditorTitleComponent extends EventEmitter {
  constructor(logger) {
    super();
    this._logger = logger;
    this._renderer = new Renderer(this);
    this._isShown = true;
    this._showActionIcon = false;
    this._title = '';

    this._registerListeners();
  }
  /*******************************************/
  /* START PRIVATE COMPONENT MODEL METHODS */
  /*******************************************/
  _registerListeners() {}
  _unregisterListeners() {}
  /*******************************************/
  /* END PRIVATE COMPONENT MODEL METHODS */
  /* START PUBLIC COMPONENT MODEL METHODS */
  /*******************************************/
  get renderer() {
    return this.getRenderer();
  }
  getRenderer() {
    return this._renderer;
  }
  get logger() {
    return this._logger;
  }
  shutdown() {
    this._unregisterListeners();
    return this._renderer.shutdown().then(
      () => {
        this._renderer = undefined;
        this._logger = undefined;
        this._isShown = undefined;
        this._title = undefined;
      },
      (err) => {
        this._logger.warn(err, 'GameEditorTitleComponent.shutdown() error');
      }
    );
  }
  get title() {
    return this.getTitle();
  }

  set title(newTitle) {
    this.setTitle(newTitle);
  }

  getTitle() {
    return this._title;
  }

  setTitle(newTitle) {
    this._title = newTitle;
    this.emit('TitleChanged', newTitle);
  }

  get isShown() {
    return this.getIsShown();
  }

  set isShown(val) {
    this.setIsShown(val);
  }

  getIsShown() {
    return this._isShown;
  }

  setIsShown(val) {
    this._isShown = val;
    this.renderer.render();
  }
  get showActionIcon() {
    return this.getShowActionIcon();
  }

  set showActionIcon(boolean) {
    this.setShowActionIcon(boolean);
  }

  getShowActionIcon() {
    return this._showActionIcon;
  }

  setShowActionIcon(boolean) {
    this._showActionIcon = boolean;
    this.emit('showActionIconChanged', boolean);
  }
  get actionIconTitle() {
    return this.getActionIconTitle();
  }
  set actionIconTitle(iconTitle) {
    this.setActionIconTitle(iconTitle);
  }
  setActionIconTitle(iconTitle) {
    this._iconTitle = iconTitle;
  }
  getActionIconTitle() {
    return _.get(this, '_iconTitle', 'Description');
  }
  get actionIconType() {
    return this.getActionIconType();
  }

  set actionIconType(typeName) {
    this.setActionIconType(typeName);
  }

  getActionIconType() {
    return _.get(this, '_actionIconType', 'action-icon-gl');
  }

  setActionIconType(typeName) {
    this._actionIconType = typeName;
  }
  get actionIconName() {
    return this.getActionIconName();
  }

  set actionIconName(iconName) {
    this.setActionIconName(iconName);
  }

  getActionIconName() {
    return _.get(this, '_actionIconName', null);
  }

  setActionIconName(iconName) {
    this._actionIconName = iconName;
  }
  show() {
    //TODO - do we
    this._isShown = true;
    this.renderer.render();
  }
  hide() {
    //TODO -
    this._isShown = false;
    this.renderer.render();
  }
  /*******************************************/
  /* END COMPONENT MODEL METHODS */
  /* START HANDLER METHODS */
  /*******************************************/
  onActionIconClicked() {
    this.emit('actionIconClicked');
  }
  /*******************************************/
  /* END HANDLER METHODS */
  /* START PRIVATE METHODS */
  /*******************************************/

  /*******************************************/
  /* END PRIVATE METHODS */
  /* START PUBLIC API METHODS */
  /*******************************************/

  /*******************************************/
  /* END PUBLIC API METHODS */
  /*******************************************/
}
module.exports = GameEditorTitleComponent;
